<template>
  <nav class="left-menu">
    <v-list
      class="items"
      nav
      flat
      dense
    >
      <v-list-item-group
        active-class="peacock"
        mandatory
        class="d-inline-flex d-lg-block"
      >
        <v-list-item
          v-for="(link, index) in navLinks"
          :key="index"
          class="item mr-5 mr-lg-0 mb-0 mb-lg-5"
          :to="link.to"
          :disabled="index==2 && isVehicleAppsDisabled"
          link
        >
          <v-img
            class="item-icon"
            :src="link.icon"
            width="30px"
            height="30px"
          />
          <v-list-item-title
            class="item-title"
            :class="index!=2 || (index==2 && !isVehicleAppsDisabled) ? 'enabled' : 'disabled'"
          >
            {{ link.title }}
          </v-list-item-title>
        </v-list-item>
      </v-list-item-group>
    </v-list>
  </nav>
</template>

<script>
import { mapState, mapActions } from 'vuex'
import { ProductType } from '@/helpers/enums'
import VisibilityHelper from '@/helpers/visibilityHelper'
export default {
  name: 'HomeMenu',
  data: () => ({
    drawer: true,
    miniVariant: false,
    authorized: localStorage.getItem('authorized')
  }),

  computed: {
    ...mapState('trucks', ['trucks']),
    ...mapState('account', ['hasAppLibrary', 'featureFlags']),
    isVehicleAppsDisabled() {
      return (
        (this.trucks && this.trucks.length === 0) ||
        VisibilityHelper.hasOnlyThirdPartyVehicles(this.trucks || [])
      )
    },
    navLinks() {
      const links = [
        {
          to: {
            name: 'portal-services',
            params: { type: ProductType.Service }
          },
          icon: this.menuIconUrl('portal-services'),
          title: this.$t('home_menu.txt.services'),
          order: 1
        }
      ]
      if (this.featureFlags.useDataServices) {
        links.push({
          to: {
            name: 'data-services',
            params: { type: ProductType.DataService }
          },
          icon: this.menuIconUrl('data-services'),
          title: this.$t('home_menu.txt.data_services'),
          order: 2
        })
      }

      if (this.featureFlags.useVehicleApps) {
        links.push({
          to: { name: 'vehicleApps' },
          icon: this.menuIconUrl('vehicleApps', 'mobile-services'),
          title: this.$t('home_menu.txt.vehicle_apps'),
          order: 3
        })

        if (this.hasAppLibrary) {
          links.push({
            to: { name: 'appLibrary' },
            icon: this.menuIconUrl('appLibrary', 'mobile-services'),
            title: this.$t('home_menu.txt.app_library'),
            order: 5
          })
        }
      }

      links.push({
        to: { name: 'vehicles' },
        icon: this.menuIconUrl('vehicles'),
        title: this.$t('home_menu.txt.vehicles'),
        order: 4
      })

      links.sort((x, y) => x.order - y.order)
      return links
    }
  },
  beforeDestroy() {
    if (typeof window !== 'undefined') {
      window.removeEventListener('resize', this.onResize, { passive: true })
    }
  },
  mounted() {
    this.onResize()
    window.addEventListener('resize', this.onResize, { passive: true })
  },
  async created() {
    await this.getVehicles()
  },
  methods: {
    ...mapActions('trucks', ['getVehicles']),
    onResize() {
      this.miniVariant = this.$vuetify.breakpoint.smAndDown
    },
    openSubPage(item) {
      this.$emit('vehicles_subpage', item)
    },
    menuIconUrl(routeName, iconSource) {
      let suffix = ''
      if (routeName != this.$route.name) {
        suffix = '-outline'
      }
      try {
        return require(`../assets/imgs/${iconSource || routeName}${suffix}.svg`)
      } catch {}
      return ''
    }
  }
}
</script>

<style lang="scss">
.left-menu {
  .items {
    background-color: var(--v-pale-base);
    padding: 0;

    .item {
      padding: 0 10px;
      width: 176px;
      height: 40px;
      justify-content: left;

      .item-title {
        overflow: unset;
        text-overflow: unset;
        white-space: normal;
      }

      &.v-list-item--active {
        box-shadow: 0 3px 17px 0 rgba(0, 0, 0, 0.22) !important;

        .item-title {
          color: white !important;
        }
      }

      &-icon {
        margin-right: 8px;
        i {
          font-size: 1.375rem;
          opacity: 0.3;
        }
        &.enabled {
          i {
            color: var(--v-peacock-base) !important;
          }
        }
        &.disabled {
          i {
            color: var(--v-cloudy-base) !important;
          }
          filter: grayscale(1);
        }
      }

      &-title {
        text-transform: none;
        font-size: 0.875rem;
        font-weight: 500;
        line-height: normal;
        letter-spacing: 1px;

        &.enabled {
          color: var(--v-peacock-base) !important;
        }
        &.disabled {
          color: var(--v-cloudy-base) !important;
        }
      }
    }
  }
}
</style>